import { useState } from 'react';
import Persona from 'persona';
import axios from 'axios';
import { LoadingMode } from '../Components/LoadingMode';

import './persona.css';
import { getToken, windowReload } from '../utils';

function PersonaVerification() {
  const { token: userToken } = getToken();

  const [ready, setReady] = useState(false);

  const handleCompleteVerification = async (inquiryId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/persona/verify`,
        {
          inquiry_id: inquiryId,
        },
        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );

      if (!!response && response?.data.status === 'success') {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/auth/refresh`,
          {},
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );

        let currentData = JSON.parse(sessionStorage.getItem('user'));

        currentData.user.persona = data.persona;

        sessionStorage.setItem('user', JSON.stringify(currentData));
      }
    } catch (error) {
      console.log(error);
    } finally {
      windowReload();
    }
  };

  return (
    <div className='h-screen w-full grid place-content-center'>
      <div style={{ display: ready ? 'none' : 'unset', fontWeight: 600 }}>
        <LoadingMode />
      </div>
      <div className={ready ? 'grid place-content-center w-[40px] ' : 'none'}>
        <Persona.Inquiry
          className='w-fit'
          templateId={process.env.REACT_APP_PERSONA_TEMPLATE_ID}
          environmentId={process.env.REACT_APP_PERSONA_ENVIRONMENT_ID}
          onReady={() => setReady(true)}
          onComplete={({ inquiryId, status, fields }) => {
            // Inquiry completed. Optionally tell your server about it.
            console.log(`Sending finished inquiry ${inquiryId} to backend`);
            handleCompleteVerification(inquiryId);
          }}
          onCancel={({ inquiryId, sessionToken }) => console.log('onCancel')}
          onError={(error) => console.log(error)}
        />
      </div>
    </div>
  );
}

export default PersonaVerification;
